

















































import Vue from 'vue';
import CustomerTable from '../search/CustomerTable.vue';
import CustomerDisplaySettings from '../search/CustomerDisplaySettings.vue';
import CustomerGroupSettings from '../search/CustomerGroupSettings.vue';
import customerVuex from '@/customer/vuex/common';
import massClient from '../../../mass/apis';
import { TaskType } from '../../../common/models/TaskType';
import Task from '../../../common/models/Task';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    CustomerTable,
    CustomerDisplaySettings,
    CustomerGroupSettings,
  },
  data() {
    return {
      resultHeight: 0,
      loaded: false,
      showGroupSettings: false,
      hasRuningTask: false,
      initIds: [],
    };
  },
  computed: {
    resultStyles(): any {
      return {
        height: `${this.resultHeight}px`,
      };
    },
    groupOpenids(): number[] {
      const openids = this.customerState.customerList.data.map((c: any) => c.openid);
      if (openids.length <= 100) {
        return openids;
      } else {
        return [];
      }
    },
  },
  methods: {
    refreshCustomers() {
      this.showGroupSettings = false;
      setTimeout(() => {
        this.$store.commit('CUSTOMER_TABLE_REFRESH');
      }, 1000);
    },
    getTasks() {
      massClient.getTaskByTypes({
        page: 1,
        size: 10,
        tpes: [TaskType.GroupAppend, TaskType.GroupRemove]}).success((res) => {
        if (res.tasks.filter((r: Task) => r.status === 0 || r.status === 1 ).length > 0) {
          this.hasRuningTask = true;
        }
      });
    },
    checkShowGroupSettings() {
      if (!this.hasRuningTask) {
        this.showGroupSettings = true;
      } else {
        this.showGroupSettings = false;
        this.$Message.warning('尚有分组任务未完成，请稍后再试');
      }
    },
    toMpGroup() {
      window.location.href = '#/mass/mpgroup?from=filter';
    },
    toWxTpl() {
      window.location.href = '#/mass/wxtpl?from=filter';
    },
    showCustomerExport() {
      if (this.accountState.crmLevel) {
        this.$store.commit('SHOW_CUSTOMER_EXPORT');
      } else {
        this.$Message.warning('权限不足，试用期会员不支持粉丝导出');
      }
    },
    showCustomerAnalyze() {
      this.$store.commit('SHOW_CUSTOMER_ANALYZE');
    },
    setResultHeight() {
      this.resultHeight = window.document.body.offsetHeight - 120;
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.setResultHeight();
    });
    this.$nextTick(() => {
      this.setResultHeight();
    });
    this.getTasks();
  },
});
